function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useMemo } from 'react';
import { guid } from '@bydesign-ui/utils';
import { RcPopper, RcTriggerGroup } from '../../hooks/popper';
import { PopoverContent } from './PopoverContent';
export function SingletonPopover(props) {
  var children = props.children,
      popoverClassName = props.popoverClassName,
      popoverStyle = props.popoverStyle,
      extra = _objectWithoutProperties(props, ["children", "popoverClassName", "popoverStyle"]);

  var triggerId = useMemo(function () {
    return guid();
  }, []);
  var triggerIds = useMemo(function () {
    return [triggerId];
  }, []);
  return React.createElement(RcPopper, null, React.createElement(RcTriggerGroup, {
    triggerGroupId: triggerId
  }, children), React.createElement(PopoverContent, Object.assign({}, extra, {
    style: popoverStyle,
    className: popoverClassName,
    triggerIds: triggerIds
  })));
}